import companyInfo from './get';
import validation from './validation';

export default [companyInfo, validation];
